import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NoPage from './components/404';
import Home from './components/home';
import Manuals from './components/manuals/all-manuals';
import HazardousMaterials from './components/manuals/hazardous-materials';
import InternationalProcedures from './components/manuals/international-procedures';
import MinimumEquipmentList from './components/manuals/minimum-equipment-list';
import RvsmOperations from './components/manuals/rvsm-operations';
import SOPS from './components/manuals/sops';
import Training from './components/manuals/training';
import News from './components/news';
import Regulations from './components/regulations/fars';
import LegalInterpretations from './components/regulations/legal-interpretations';
import SearchDetails from './components/search/search-details';
import About from './components/services/about';
import CertificationService from './components/services/certification-service';
import ComplianceManagement from './components/services/compliance-management';
import ComplianceServices from './components/services/compliance-services';
import ContactUsPage from './components/contact-us';
import DigitalSolution from './components/services/digital-solution';
import SMS from './components/services/sms';
import ElectronicFlightBag from './components/software/flight-bag';
import Levelflight from './components/software/levelflight';
import ElectronicRecordKeeping from './components/software/recordkeeping';
import SoftwareSolutions from './components/software/solutions';
import ComplianceSeminar from './components/training/compliance-seminar';
import InternationalTraining from './components/training/international-training';
import PilotTraining from './components/training/pilot-training';
import StandardizedTraining from './components/training/standardized-training';
import Whitepapers from './components/whitepapers';
import './index.scss';
import SafetyStandard from './components/safety/safety-standard';
import SafetyBoard from './components/safety/safety-board';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        <Route path="/" element={<Home />} />
        <Route path="/search/:id" element={<SearchDetails />} />
        <Route path="/services" element={<ComplianceServices />} />
        <Route path="/contact-us" element={<ContactUsPage />} />
        <Route path="/services/about" element={<About />} />
        <Route path="/services/compliance-management" element={<ComplianceManagement />} />
        <Route path="/services/certification-services" element={<CertificationService />} />
        <Route path="/services/digital-solutions" element={<DigitalSolution />} />
        <Route path="/services/safety-management-system" element={<SMS />} />

        <Route path="/software" element={<SoftwareSolutions />} />
        <Route path="/software/electronic-flight-bag" element={<ElectronicFlightBag />} />
        <Route path="/software/levelflight" element={<Levelflight />} />
        <Route path="/software/electronic-recordkeeping" element={<ElectronicRecordKeeping />} />

        <Route path="/manuals" element={<Manuals />} />
        <Route path="/manuals/training" element={<Training />} />
        <Route path="/manuals/sops" element={<SOPS />} />
        <Route path="/manuals/rvsm-operations" element={<RvsmOperations />} />
        <Route path="/manuals/hazardous-materials" element={<HazardousMaterials />} />
        <Route path="/manuals/minimum-equipment-list" element={<MinimumEquipmentList />} />
        <Route path="/manuals/international-procedures" element={<InternationalProcedures />} />

        <Route path="/training" element={<PilotTraining />} />
        <Route path="/training/standardized-training" element={<StandardizedTraining />} />
        <Route path="/training/international-training" element={<InternationalTraining />} />
        <Route path="/training/understanding-the-why-in-135" element={<ComplianceSeminar />} />

        <Route path="/regulations" element={<Regulations />} />
        <Route path="/regulations/legal-interpretations" element={<LegalInterpretations />} />

        <Route path="/safety/safety-standard" element={<SafetyStandard />} />
        <Route path="/safety/safety-board" element={<SafetyBoard />} />

        <Route path="/news" element={<News />} />
        <Route path="/whitepapers" element={<Whitepapers />} />  Safety: [

        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
  );
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
